<template>
  <div id="map">
    <v-container fluid id="container-map">
      <v-layout row wrap>
        <v-flex xs12 sm12 md4>
          <v-btn outline large color="black" class="btn-black ml-2 mb-3" @click="downloadData()">
            Descargar Datos
          </v-btn>
        </v-flex>
        <v-flex xs6 sm6 md5>
          <p class="busqueda text-xs-right">Tu búsqueda</p>
        </v-flex>
        <v-flex xs6 sm6 md3>
          <p class="resultado text-xs-center">Resultado</p>
          <p class="homicidios">
            <span class="cifra"> {{ reports.length }} </span> Homicidios
          </p>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center align-content-center>
        <v-flex xs12 sm9 xs9>
          <div id="mapid"></div>
        </v-flex>
        <v-flex xs12 sm9 md3 class="pl-1">
          <States />
        </v-flex>
      </v-layout>
      <hr class="note-line" />
      <p class="note">
        Si cuentas con información sobe el homicidio de una persona LGBT, que no
        se encuentre registrado, puedes hacernos llegar la información al
        siguiente correo: delitosdeodiolgbt@gmail.com
      </p>
      <p class="note italic">
        Esta información puede ser reproducida parcial o totalmente siempre y
        cuando se cite la fuente.
      </p>
      <v-dialog
        v-model="dialog"
        max-width="800"
      >
        <v-card>
          <img src="">
          <p>hello</p>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import L from "leaflet";
import States from "@/components/States";
import Card from "@/components/Card";
import { mapGetters } from "vuex";

export default {
  name: "Map",

  data() {
    return {
      mymap: undefined,
      markers: [],
      markerLayer: undefined,
      dialog: false,
      markerClusters: undefined
    };
  },
  components: {
    States,
    Card
  },
  computed: {
    reports: {
      get() {
        return this.$store.state.filteredReports;
      }
    }
  },
  watch: {
    "$store.state.selection": function() {
      if (this.$store.state.selection){
        // console.log(this.markers.find(marker => {return marker.folio == this.$store.state.selection}));
        this.markers
          .find(marker => {
            return marker.folio == this.$store.state.selection;
          })
          .fire("click");
      }else{ 
        this.mymap.closePopup();
      }
    },
    "$store.state.filteredReports": function() {
      this.drawMarkers();
    }
  },
  methods: {
    drawMap() {
      this.mymap = L.map("mapid").setView([23.6345, -102.5528], 5);
      this.mymap.scrollWheelZoom.disable();

      L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: "mapbox/light-v10",
          accessToken:
            "pk.eyJ1IjoibmVsbHktcmFtaXJleiIsImEiOiJjanJ3N3NyaHUwOGV0NDVuY2FleXc5YXB3In0.r1Gvt3uxgR8o36CcDMd3Bw"
        }
      ).addTo(this.mymap);

      this.mymap.on("popupclose", () => {
        this.$store.commit("setSelection", undefined);
      });
      //console.log('map');

      this.drawMarkers();
    },
    drawMarkers() {
      // console.log(this.markerLayer, this.markerLayer ? true : false, 'layer');
      this.markers = [];
      if (this.markerLayer) {
        this.markerLayer.clearLayers();
        this.markerClusters.clearLayers();
      }
      // if(this.markerClusters) {
      //   console.log("remoce")
      //   markerClusters.clearLayers();
      // }

      this.markerClusters = L.markerClusterGroup();
      
      this.reports.forEach(report => {
      //for(let report of this.reports){
        const svg = `
        <?xml version="1.0" encoding="UTF-8"?>
        <svg width="30px" height="37px" viewBox="0 0 30 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
            <title>Shape</title>
            <desc>Created with Sketch.</desc>
            <defs>
                <path d="M738,1112 C731.918571,1112 727,1116.5385 727,1122.15 C727,1129.7625 738,1141 738,1141 C738,1141 749,1129.7625 749,1122.15 C749,1116.5385 744.081429,1112 738,1112 L738,1112 Z M734,1122 C734,1119.792 735.7248,1118 737.85,1118 C739.9752,1118 741.7,1119.792 741.7,1122 C741.7,1124.208 739.9752,1126 737.85,1126 C735.7248,1126 734,1124.208 734,1122 Z" id="path-1"></path>
                <filter x="-31.8%" y="-17.2%" width="163.6%" height="148.3%" filterUnits="objectBoundingBox" id="filter-2">
                    <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                    <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                    <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.258520154 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
                </filter>
            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="RRM_back02" transform="translate(-723.000000, -1110.000000)">
                    <g id="Shape">
                        <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                        <use fill="#be3117" fill-rule="evenodd" xlink:href="#path-1"></use>
                    </g>
                </g>
            </g>
        </svg>
        `;
        const redIcon = L.divIcon({
          className: "pin",
          html: svg,
          iconAnchor: [16, 34],
          popupAnchor: [0, -35]
        });
        
        let marker = L.marker(report.marker, { icon: redIcon });
        
        let html = `
          <p class='tooltip-text'> ${report.state}, <span class='cifra'>${
              report.year
            }</span> </p>`

        html += report.postal && report.postal.url ? `
          <v-btn class='btn-popup' onclick="window.open('${report.postal.url}', '_blank')"> Ver Postal</v-btn>` : ``;

        marker.bindPopup(html);
        marker.folio = report.folio;
        marker.on("click", e => {
          const folio = e.sourceTarget.folio;
          this.$store.commit("setSelection", folio);
          if (!marker._icon) marker.__parent.spiderfy();
          marker.openPopup();
        });

        // marker.addTo(this.mymap);
        this.markers.push(marker);
        this.markerClusters.addLayer(marker);
        this.mymap.addLayer(this.markerClusters);
        
      });

      //console.log(this.reports,this.markers,this.markerLayer, this.markerLayer ? true : false, 'marker');

      this.markerLayer = L.layerGroup(this.markers)
      // .addTo(this.mymap);
    },
    downloadData() {
      let lineArray = [
        "data:text/csv;charset=utf-8,Folio,Fecha del hecho, Nombre legal, Nombre elegido o asumido,Nacionalidad,Edad,Identidad de género/Orientación sexual percibida,Ocupación,Municipio,Entidad,Lugar donde apareció el cuerpo,Característica diferencial,Estado del cuerpo,Arma,¿Hubo indicios de violencia sexual?,¿Hubo indicios de tortura?,¿Hubo detenido?"];
      this.reports.forEach(infoArray => {
        let line = "";
        line += infoArray.folio + ",";
        line += infoArray.aggressionDate + ",";
        line += infoArray.legalName + ",";
        line += infoArray.chosenName + ",";
        line += infoArray.nationality + ",";
        line += infoArray.age + ",";
        line += infoArray.sexualIdentity + ",";
        line += infoArray.occupation + ",";
        line += infoArray.municipality + ",";
        line += infoArray.state + ",";
        line += infoArray.whereWasFound + ",";
        line += infoArray.characteristic + ",";
        line += infoArray.bodyState + ",";
        line += infoArray.weapon + ",";
        line += infoArray.sexualViolence + ",";
        line += infoArray.tortureViolence + ",";
        line += infoArray.wasOffenderFound + ",";
        lineArray.push(line);
      });

      let csvContent = encodeURI(lineArray.join("\n"));
      var link = document.createElement("a");
      link.setAttribute("href", csvContent);
      link.setAttribute("download", "datos-letraese.csv");
      document.body.appendChild(link);
      link.click();
    }
  },
  mounted() {
    this.drawMap();
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800");

#map {
  background-color: #f7f7f7;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 1rem;
}
#mapid {
  height: 600px;
  width: 98%;
  z-index: 0;
}

#container-map {
  padding: 0px 10% 0px 10%;
}

#map .btn-black {
  border-radius: 10px;
  font-weight: 600;
  border: 2px solid black !important;
  font-size: 12px;
  margin-top: 8%;
}

.note-line {
  margin-top: 20px;
  margin-bottom: 10px;
  width: 18%;
  border: 1px solid #be3117;
}

.note {
  font-size: 11px;
}

.italic {
  font-style: italic;
}

.busqueda {
  padding-right: 2%;
  font-size: 16px;
  margin-top: 10%;
}
#map .resultado {
  background-color: black;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  width: 50%;
}

.homicidios {
  font-weight: 900;
  font-size: 28px;
}

.cifra {
  color: #be3117;
}

.leaflet-popup-content-wrapper {
  border-radius: 0px;
  width: 178px;
  border: solid 2px black;
  background-color: #f8f8f8;
}
.leaflet-popup-tip {
  background-color: black;
}
.leaflet-popup-content {
  text-align: center;
}
.btn-popup {
  background-color: black;
  color: #ffffff;
  padding: 2px 20px 2px 20px;
  font-weight: 500;
  cursor: pointer;
}

.btn-popup:hover {
  background-color: #be3117;
  color: #ffffff;
}

.tooltip-text {
  font-weight: 600;
}

.panel {
  align-self: center;
}
</style>
